import { render } from "./LightBox.vue?vue&type=template&id=1a659d0d"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"

import "./LightBox.vue?vue&type=style&index=0&id=1a659d0d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__